import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { LoaderService } from './loader.service';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss'
})
export class LoaderComponent {
  readonly loader = inject(LoaderService);
}
